var styles = {
  "Header": "Online-Store-UI-Header_1jffi",
  "Interior": "Online-Store-UI-Header__Interior_1eua0",
  "SecondaryAction": "Online-Store-UI-Header__SecondaryAction_13m8x",
  "PrimaryAction": "Online-Store-UI-Header__PrimaryAction_1he9a",
  "PrimaryActionGroup": "Online-Store-UI-Header__PrimaryActionGroup_1dr0w",
  "PrimaryActionGroupWrapper": "Online-Store-UI-Header__PrimaryActionGroupWrapper_hxkgs",
  "MiddleAction": "Online-Store-UI-Header__MiddleAction_1cq16",
  "MiddleActionInteractive": "Online-Store-UI-Header__MiddleActionInteractive_1fw02",
  "MiddleActionButton": "Online-Store-UI-Header__MiddleActionButton_1shi8",
  "DragHandleIcon": "Online-Store-UI-Header__DragHandleIcon_1fgjb",
  "Title": "Online-Store-UI-Header__Title_1co0r",
  "TitleWrapper": "Online-Store-UI-Header__TitleWrapper_ebumo",
  "SubtitleWrapper": "Online-Store-UI-Header__SubtitleWrapper_192mf",
  "TitlePrefixWrapper": "Online-Store-UI-Header__TitlePrefixWrapper_18q19",
  "SubtitlePrefixWrapper": "Online-Store-UI-Header__SubtitlePrefixWrapper_1h67j",
  "SubtitleSuffixWrapper": "Online-Store-UI-Header__SubtitleSuffixWrapper_1ywia",
  "SuffixWrapper": "Online-Store-UI-Header__SuffixWrapper_139tb",
  "Button": "Online-Store-UI-Header__Button_1gkrb",
  "semibold": "Online-Store-UI-Header--semibold_v878r",
  "alignRight": "Online-Store-UI-Header--alignRight_c624s",
  "ButtonContentWrapper": "Online-Store-UI-Header__ButtonContentWrapper_12ppe",
  "hasPrefix": "Online-Store-UI-Header--hasPrefix_1h7eu",
  "Prefix": "Online-Store-UI-Header__Prefix_1plch",
  "Content": "Online-Store-UI-Header__Content_145jm",
  "LoadingSpinner": "Online-Store-UI-Header__LoadingSpinner_d841e",
  "PrimaryAndMoreActions": "Online-Store-UI-Header__PrimaryAndMoreActions_x4ovl"
};

export { styles as default };
